import React from "react/"
import ModalWindow from "../ModalWindow/ModalWindow"
import jsQR from 'jsqr';
import BarcodeDecoder from '../../utils/BarcodeDecoder'
import aim from '../../resouces/aim-box.svg'


interface PropsType {
    isActive: boolean,
    onClose: Function
}


export default class Camera extends React.Component<PropsType> {

    stream: MediaStream | null = null;

    videoElement: HTMLVideoElement | null = null;

    shootTimer: any = null;

    onClose() {
        this.props.onClose();

        this.shootTimer &&
            clearTimeout(this.shootTimer);

        this.stream &&
            this.stream.getTracks().forEach(function (track) {
                track.stop();
            });
    }

    onShoot() {
        const canvas = document.createElement('canvas') as HTMLCanvasElement; // create a canvas
        const ctx = canvas.getContext('2d');
        if (!ctx || !this.videoElement) return;
        let code = null;

        /**
         * Image cropping
         */

        const sw = Math.floor(this.videoElement.videoWidth * 0.5);
        const sh = Math.floor(this.videoElement.videoHeight * (1 / 3));

        const ratio = sw / sh;

        const sx = Math.floor(this.videoElement.videoWidth * 0.25);
        const sy = sh;

        const dw = 600;
        const dh = dw * ratio;

        canvas.width = dw;
        canvas.height = dh;

        ctx.drawImage(this.videoElement,
            sx, sy, sw, sh,
            0,0, dw, dh);

        console.log({lastImage: canvas.toDataURL("base64")});
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

        // QRCode
        if (!code) code = jsQR(imageData.data, imageData.width, imageData.height);

        if (code) {
            this.onClose();
            if (code.data.includes('iroll.de') ) document.location.href = "https://" + code.data;
            if (code.data.includes('explainitapp')) document.location.href = code.data;
            console.log(code);
            return;
        }

        // Barcode
        const decoder = new BarcodeDecoder(imageData);
        const result = decoder.decode();
        if (result) {
            this.onClose();
            const url = document.location.href.match(/admin[sb]*.explainitapp.com/);
            document.location.href = `https://${url}/play/?${result}`;

            return;
        }

        this.shootTimer = setTimeout(this.onShoot.bind(this), 1000);
    }

    startStreaming() {
        this.videoElement = document.querySelector('#video_view') as HTMLVideoElement;

        navigator.mediaDevices.getUserMedia({video: { facingMode: "environment"}}) // request cam
            .then(stream => {
                if (!this.videoElement) return ;
                console.log(0);
                this.stream = this.videoElement.srcObject = stream;
                console.log(1);
                //return this.videoElement.play();
            })
            .then(() => {
                if (!this.videoElement) return;
                this.shootTimer = setTimeout(this.onShoot.bind(this), 1000);
            })
            .catch(() => {
                this.onClose();
                alert("Your browser doesn't support this feature. Please use Chrome or Safari.");
            });
    }

    componentDidUpdate(prevProps: Readonly<PropsType>, prevState: Readonly<{}>, snapshot?: any): void {
        if (!prevProps.isActive && this.props.isActive) this.startStreaming();
    }

    render() {
        if (!this.props.isActive) return null;

        return (
            <ModalWindow close={this.onClose.bind(this)}>
                <video autoPlay muted playsInline
                       id="video_view"
                       onClick={ () => this.videoElement ? this.videoElement.play() : null} />
                {/*<i className="centered scanAIM fal fa-brackets" />*/}
                <img src={aim} className='centered scanAIM' alt=""/>
            </ModalWindow>
        );
    }

}